export default __webpack_public_path__ + "static/area-with-negative-values-48a6d868eee263508f08dbe13424f72f.png";